import { FC } from "react"

const WhyUs: FC = () => {
  const cards =  [
    {title: 'Персональный подход', text: 'Наши специалисты учтут особенности вашего помещения, тип задач и требования к освещению;'},
    {title: 'Экономию энергии', text: 'Оптимальное освещение поможет снизить энергопотребление и, как следствие, уменьшить ваши траты;'},
    {title: 'Эффективное сотрудничество', text: 'Подстроимся под ваш бюджет и подберем выгодное оборудование;'},
    {title: 'Соответствие ГОСТ и СанПин', text: 'Это гарантирует не только эффективность освещения, но и соблюдение нормативов по освещенности, благоприятной для здоровья и комфорта человека; '},
    {title: 'Короткие сроки', text: 'Сделаем светотехнический расчет от 1 до 2 дней в зависимости от сложности проекта.'},
  ]

 return   <div className='container-fluid why-us' id='why-us'>
   <div className="row why-us__title">
     <h1>Почему стоит выбрать нас?</h1>
   </div>
   <div className="why-us__offer-text">
     <h2>Мы предлагаем:</h2>
   </div>
   <div className="why-us__offer-cards">
     {cards.map(({title, text}, index) => (
       <div className='card' key={index}>
         <div className="back-number">{index + 1}</div>
         <div className="card-content">
           <p className='content-title'>{title}</p>
           <p className='content-text'>{text}</p>
         </div>
       </div>
     ))}
   </div>
 </div>
}

export default WhyUs;
